import { UIMessageStreamPart } from "../../../schemas/ai/ui-message-stream-part";

export const AiRoleList = ["user", "assistant", "system"] as const;
export type AiRoleType = (typeof AiRoleList)[number];

export type WebsocketAiChatStatusType =
  | "connected"
  | "disconnected"
  | "streaming"
  | "ready"
  | "error"
  | "complete";

export type WebsocketAiChatResponse = {
  type: "aiChatResponse";
  chatId: string;
  response: UIMessageStreamPart;
};
